<template>
    <div class="default_footer_block">
        <footer>
            <div class="footer-first">
                <div class="container">
                    <div class="footer-first-wrapper">
                        <div class="footer-links">
                            <NuxtLink to="/upakovka" class="footer-link">Упаковка грузов</NuxtLink>
                            <NuxtLink to="/documents" class="footer-link">Документы</NuxtLink>
                        </div>
                        <div class="footer-content">
                            <a class="footer-content-link"
                                @click="telClick"
                                href="tel:375173361999">
                                <img src="/icon/call.svg" alt="Иконка звонок"> +375 (17) 336-19-99
                            </a>
                            <p class="footer-text">ООО «ПЭК Бел»</p>
                            <p class="footer-text">УНП 193484328</p>
                            <p class="footer-text">ОКПО 504549605000</p>
                            <p class="footer-text">Юридический адрес:</p>
                            <p class="footer-text">Республика Беларусь, 220037, г. Минск, пер. Твёрдый 1-й, 11</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-second">
                <div class="container">
                    <div class="footer-second-wrapper">
                        <div class="footer-cooperating">
                            <p class="footer-cooperating-text">2026 © ООО «ПЭК Бел»</p>
                            <p class="footer-cooperating-text">О защите персональных данных</p>
                            <a class="footer-cooperating-text"
                              href="/entity/" target="_blank">
                                Технические данные для ИИ
                            </a>
                        </div>
                        <div class="footer-market">
                            <p class="footer-market-text">Управляй доставкой в приложении</p>
                            <div class="market-wrapper">
                                <a href="https://apps.apple.com/ru/app/%D0%BF%D1%8D%D0%BA-%D0%B4%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BA%D0%B0-%D1%81%D0%B1%D0%BE%D1%80%D0%BD%D1%8B%D1%85-%D0%B3%D1%80%D1%83%D0%B7%D0%BE%D0%B2/id1270225018?pt=118848033&ct=desktop_footer&mt=8" target="_blank" class="footer_content_downloads_market_link">
                                    <img src="/images/apple-store-small.svg" alt='Лого Скачайте из App Store'/>
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=ru.pecom.android&referrer=utm_source%3Dm.pecom.ru%26utm_medium%3Dfree%26utm_campaign%3Ddesktop_footer" target="_blank" class="footer_content_downloads_market_link">
                                    <img src="/images/google-play-small.svg" alt='Лого Скачайте из Google Play'/>
                                </a>
                                <a href="https://appgallery.huawei.com/#/app/C103473351" target="_blank" class="footer_content_downloads_market_link">
                                    <img src="/images/app-gallery-small.svg" alt='Лого Скачайте из App Gallery'/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script setup>
</script>

<style scoped>
.default_footer_block {
    width: 100%;
}

footer {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0;

    @media screen and (max-width: 1300px) {
        &:not(.no-padding) {
            max-width: unset;
            margin: 0;
            padding: 0 16px;
        }
    }
}

.footer-first {
    background-color: #2E2E2E;
    padding: 40px 0;
}

.footer-first-wrapper {
    display: flex;
    justify-content: space-between;
}

.footer-links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
}

.footer-link {
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
    color: #FFFFFF;
    text-decoration: none;
}

.footer-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.footer-content-link {
    display: flex;
    gap: 8px;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    color: #757575;
    margin-bottom: 32px;
    text-decoration: none;
    margin: 0;
}

.footer-text {
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    margin: 0;
    color: #757575;
}

.footer-second {
    padding: 32px 0;
    background-color: #252525;
}

.footer-second-wrapper {
    display: flex;
    justify-content: space-between;
}

.footer-cooperating-text {
    font-family: Roboto;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    color: #FFFFFF;
    margin: 0;
    text-decoration: none;
}

.footer-market {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
}

.footer-market-text {
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    color: #FFFFFF;
    margin: 0;
}

.market-wrapper {
    display: flex;
    gap: 16px;
}

@media screen and (max-width: 1279px) {
    .footer-first {
        padding: 60px 0;
    }

    .footer-second {
        padding: 32px 0;
    }

    .footer-second-wrapper {
        flex-direction: column;
        gap: 33px;
        align-items: flex-start;
    }
}

@media screen and (max-width: 768px) {
    .footer-first-wrapper {
        flex-direction: column;
        gap: 40px;
        align-items: flex-start;
    }

    .footer-first {
        padding: 48px 0;
    }

    .footer-second-wrapper {
        flex-direction: column-reverse;
        align-items: flex-start;
    }
    .footer-market {
        align-items: center;
    }
    .market-wrapper {
        flex-wrap: wrap;
    }
}
</style>
